// extracted by mini-css-extract-plugin
export default {"stosks_column":"styles_stosks_column__EUD+6","link_download":"styles_link_download__ng7oB","main_block":"styles_main_block__WTbU7","text_time":"styles_text_time__aZyJQ"};